// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ByhP","title":"Header_title__2uCL2","left":"Header_left__iNOC3","clinicName":"Header_clinicName__2f38D"};